import { useMutation } from "@tanstack/react-query";
import { API_ROUTES } from "../../constants";
import { apiClient } from "./apiClient";

/**
 * Hook to generate/update title for a chat session
 */
export const useGenerateChatTitle = () => {
  return useMutation({
    mutationFn: async (sessionId: string) => {
      const response = await apiClient.get<{ title: string }>(
        API_ROUTES.omniSearch.chatTitle(sessionId)
      );
      return response.data;
    },
  });
};
